import React from 'react';
import { Heart } from 'lucide-react';
import { motion } from 'framer-motion';
interface FavoriteButtonProps {
  isFavorite: boolean;
  onClick: () => void;
  size?: number;
}
export function FavoriteButton({
  isFavorite,
  onClick,
  size = 14
}: FavoriteButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };
  return <motion.button onClick={handleClick} className="p-1.5 rounded-lg bg-white/5 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all cursor-pointer" whileTap={{
    scale: 0.9
  }} whileHover={{
    scale: 1.05
  }} type="button" data-id="element-278">
      <motion.div animate={{
      scale: isFavorite ? [1, 1.2, 1] : 1
    }} transition={{
      duration: 0.3
    }} data-id="element-279">
        <Heart size={size} className={`transition-colors ${isFavorite ? 'fill-red-500 text-red-500' : 'text-gray-400'}`} data-id="element-280" />
      </motion.div>
    </motion.button>;
}